<mat-form-field class="bold-required-field">
  <mat-label> {{ fieldLabel }}{{ getLabelSuffix() }} </mat-label>
  <input
    *ngIf="!isSelect"
    matInput
    autocomplete="needAutocomplete"
    [matAutocomplete]="driverAutocomplete"
    [formControl]="fieldControl"
    [attr.test-id]="testId"
    [readonly]="isReadonly"
  />

  <mat-select *ngIf="isSelect" [formControl]="fieldControl" [attr.test-id]="testId">
    <mat-option *ngFor="let type of values" [value]="type" [attr.test-id]="type">
      {{ 'monitoring.uli.create.driverInfo.idTypes.' + type | translate }}
    </mat-option>
  </mat-select>
  <ui-svg-icon
    *ngIf="isSelect && fieldControl.value"
    [name]="iconNames.Close"
    matSuffix
    (click)="onClearButtonClick($event)"
  ></ui-svg-icon>

  <mat-error>
    <ui-field-error-messages [control]="fieldControl"></ui-field-error-messages>
  </mat-error>
</mat-form-field>

<mat-autocomplete #driverAutocomplete="matAutocomplete">
  <mat-option
    *ngFor="let driver of values"
    class="frequent-driver-autocomplete-option"
    (onSelectionChange)="onDriverSelected(driver)"
  >
    <div class="driver-option__wrap">
      <span>
        <span class="driver__name">{{ driver.firstName }} {{ driver.lastName }}</span>
        <span class="driver-option__phone-number">
          {{ driver.phoneNumber }}
        </span>
      </span>

      <span *ngIf="driver.permitType" class="driver-option__info">
        {{ 'monitoring.uli.create.driverInfo.idTypes.' + driver.permitType | translate }}:
        {{ driver.permitNumber }}
      </span>

      <span class="driver-option__info">
        {{ driver.carrierName }} {{ driver.carrierNumber }} ({{ driver.carrierExtId }})
      </span>
    </div>
  </mat-option>
</mat-autocomplete>
